(function () {
  function initBentoTile(tile) {
    if (tile.dataset.wudyBentoInit === 'true') return;
    tile.dataset.wudyBentoInit = 'true';

    var img = tile.querySelector('.wudy-category-tile__img');
    if (!img || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    tile.addEventListener('mousemove', function (e) {
      var rect = tile.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      img.style.transform = 'scale(1.08) translate(' + (x * 10) + 'px, ' + (y * 10) + 'px)';
    });

    tile.addEventListener('mouseleave', function () {
      img.style.transform = '';
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-wudy-bento-tile]').forEach(initBentoTile);
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot();
  });
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
